import React from 'react';
import PropTypes from 'prop-types';
import { Button, Switch } from 'antd';
import { DeleteOutlined, CheckOutlined } from '@ant-design/icons';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import styles from './styles.less';
import { EditorContext } from '../../hoc/Editor';
import { RouteContext } from '../../hoc/Route';
import ImageUpload from '../InlineEditor/ImageUpload';
import { LocalizationContext } from '../../hoc/Localization';

const temp = [];

const Gallery = ({ images, canEdit, course }) => {
  const { page } = React.useContext(RouteContext);
  const { t } = React.useContext(LocalizationContext);
  const { editMode, edited, updateContent } = React.useContext(EditorContext);
  const [width, setWidth] = React.useState(null);
  React.useEffect(() => {
    setWidth(window.innerWidth);
  }, []);

  const filteredImages = images.filter(image => !image.deleted);
  // eslint-disable-next-line
  const changedImages = filteredImages.map(image =>
    image.url && !image.url.includes('googleapis')
      ? {
        url: image.url
          .substring(0, image.url.lastIndexOf('.'))
          .concat('-small')
          .concat(image.url.slice(image.url.lastIndexOf('.'), image.url.length)),
      }
      : { url: image },
  );

  const setGalleryImage = url => {
    temp.push({ url });
    const imageData = updateContent({
      ...edited,
      images:
        edited.images && edited.images.length > 1 && edited.images.includes('googleapis')
          ? [...edited.images, ...temp]
            .slice(-10)
            .filter(element => !element.thumbnail.includes('googleapis'))
          : temp.slice(-10),
    });
    return imageData;
  };

  const deleteGalleryImage = url => {
    const { images: initialImages } = edited;

    initialImages.map((image, index) => {
      if (image.url === url) {
        initialImages[index].deleted = true;
        updateContent({ ...edited, images: initialImages });
      }
      return null;
    });
  };
  const galleryImages =
    filteredImages && filteredImages.length
      ? filteredImages.map((image, index) => ({
        index,
        original: image.url,
        thumbnail: image.url.includes('static') ? image.url : changedImages[index].url,
        // eslint-disable-next-line
          renderThumbInner: ({ thumbnail, original }) => {
          return (
            <div className={styles.thumbnailContainer}>
              {editMode && ['school', 'createSchool', 'course', 'createCourse'].includes(page) && (
              <Button
                className={styles.deleteButton}
                onClick={() => {
                  deleteGalleryImage(original);
                }}
                type="primary"
                shape="circle"
              >
                <DeleteOutlined />
              </Button>
              )}
              <img src={thumbnail} alt="thumbnail" />
            </div>
          );
        },
      }))
      : [
        {
          original: '/static/images/school/default.png',
          thumbnail: '/static/images/school/default.png',
        },
        {
          original: '/static/images/school/default.png',
          thumbnail: '/static/images/school/default.png',
        },
        {
          original: '/static/images/school/default.png',
          thumbnail: '/static/images/school/default.png',
        },
      ];

  const options = {
    showIndex: false,
    showBullets: false,
    showNav: false,
    showPlayButton: false,
    infinite: false,
    lazyLoad: true,
    preventDefaultTouchmoveEvent: false,
  };
  return (
    <div id="gallery" className={styles.gallery}>
      {canEdit &&
        (page === 'school' ||
          page === 'createSchool' ||
          page === 'course' ||
          page === 'createCourse') &&
        editMode && (
          <div className={styles.uploadContainer}>
            <ImageUpload
              uploadHandler={setGalleryImage}
              text={t('school.edit.galley')}
              multiple
              type="school"
              folder="gallery"
            />
            <p className={styles.imgUloadText}>
              <CheckOutlined className={styles.imgUloadCheckIcon} />
              {t('image.upload.max.count10')}
            </p>
          </div>
      )}
      {canEdit && page === 'course' && editMode && (
        <div className={styles.showGallery}>
          <div>
            <span>{t('show.school.gallery')}</span>
          </div>
          <Switch
            size="small"
            checked={course && !edited.schoolGalleryHidden}
            onChange={() => {
              updateContent({ ...edited, schoolGalleryHidden: !edited.schoolGalleryHidden });
            }}
          />
        </div>
      )}
      {editMode && <p>{t('gallery.text')}</p>}
      {width && (
        <ImageGallery
          key={JSON.stringify(galleryImages)}
          startIndex={0}
          items={galleryImages}
          {...options}
        />
      )}
    </div>
  );
};

Gallery.propTypes = {
  images: PropTypes.array,
  canEdit: PropTypes.bool,
  course: PropTypes.object,
};

Gallery.defaultProps = {
  images: [],
  canEdit: false,
  course: {},
};

export default Gallery;
